import formatDate from "@utils/format-date";
import parseISO from 'date-fns/parseISO'
import lastDayOfMonth from 'date-fns/lastDayOfMonth'

export default function foramtMonthToDate(yearMonth) {
  return {
    startDate: yearMonth
      ? `${ yearMonth }-01`
      : '',
    endDate: yearMonth
      ? formatDate(lastDayOfMonth(parseISO(yearMonth)), 'yyyy-MM-dd')
      : ''
  }
}
